"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHistoryPaymentExtraReducers = void 0;
const tslib_1 = require("tslib");
const services_1 = tslib_1.__importDefault(require("../../services"));
const utils_1 = require("../../utils");
const toolkitRaw = tslib_1.__importStar(require("@reduxjs/toolkit"));
const getHistoryPayment = toolkitRaw.createAsyncThunk('bookings/fetch_history_payment', async (id, { rejectWithValue }) => {
    try {
        const response = await services_1.default.get(`/api/saas/me/bookings/${id}/payments`);
        const payload = (0, utils_1.deserialize)(response.data);
        return payload;
    }
    catch (eventError) {
        return rejectWithValue(eventError);
    }
});
const getHistoryPaymentExtraReducers = (builder) => {
    builder.addCase(getHistoryPayment.pending, (state) => {
        state.createBooking.historyPayments.loading = true;
    });
    builder.addCase(getHistoryPayment.fulfilled, (state, action) => {
        state.createBooking.historyPayments.loading = false;
        state.createBooking.historyPayments.data = action.payload.data;
    });
    builder.addCase(getHistoryPayment.rejected, (state) => {
        state.createBooking.historyPayments.loading = false;
    });
};
exports.getHistoryPaymentExtraReducers = getHistoryPaymentExtraReducers;
exports.default = getHistoryPayment;
//# sourceMappingURL=getHistoryPayment.js.map